export const ZoomTypes = {
    Search: 2,
    Choose: 3,
    Zoom: 4
};
